import ArrowRotateRight from './src/arrow-rotate-right-combined';
export default ArrowRotateRight;